const fnSort = (a, b) => {
  if (a.pos === b.pos) {
    return 0;
  }
  return a.pos > b.pos ? -1 : 1;
  
}
const FacFnCopyXLS = (list, listIncludeRaw, tableCss = "") => {
  
  
  const listInclude = listIncludeRaw.map((k, pos) => {
    return {field: k, pos}
  }).sort(fnSort).map(k => {
    return k.field;
  })
  
  const header = '<tr>' + listInclude
    .map(s => {
      return `<td style="background-color: #ccc; font-weight: bolder">${s.toString().toUpperCase()}</td>`;
    })
    .join('') + '</tr>';
  
  
  const body = list.map(row => {
    const text = listInclude
      .map(key => {
        return `<td>${row[key]}</td>`
      })
      .join('');
    return `<tr>${text}</tr>`
  }).join('');
  
  
  const html = `<table ${tableCss}><thead>${header}</thead><tbody>${body}</tbody></table>`;
  const elem = document.createElement("input");
  elem.setAttribute('type', 'text');
  document.body.append(elem);
  elem.value = html
  elem.select();
  document.execCommand("copy");
  elem.remove();
  
  
}

export default FacFnCopyXLS;